import { $GET, $POST } from '@/api/gateway/gatewayMethods';
import {GET_SYSTEM_LOG,
        GET_ACTION_MENU } from '@/api/endpoint-defines/systemLog';
export const getSystemLog = ({ BodyData }) =>
  $POST({ EndPoint: GET_SYSTEM_LOG, BodyData })

export const getActionMenu = () =>
  $GET({ EndPoint: GET_ACTION_MENU, QueryParameters: null })
